import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AB_API_SENTOO_APPROVE } from "../../../app/shared/constants";
import {
  ApiClientService, ApiResponse
} from "../../../app/shared/services/api-client.service";

export interface ApproveRequest {
  challengeCode: string;
  signature: string;
  transfers?: {
    TransferId: number;
    TransferFrequency: string;
    NumberOfApprovalsRemaining: number;
    SentooTransactionId: string;
    SentooProcessorId: string;
    IsApproved: boolean;
  }[];
  TokenType?: string;
  DeviceId?: string;
  ClientIp?: string;
  BrowserInfo?: {
    FingerPrintHash: string;
    FingerPrintRaw: string;
  };
}

export interface ApproveResponse extends ApiResponse {
  numberOfApprovalsRequired: number;
  url: string;
  beneficiaryName: string;
}

@Injectable({
  providedIn: "root",
})
export class ApproveService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_SENTOO_APPROVE);
  }

  approveTransfer(request: ApproveRequest): Observable<ApproveResponse > {
    return this.post(request);
  }
}
